import { render } from "./ThePatientConsultation.vue?vue&type=template&id=0d8ea6d3&ts=true"
import script from "./ThePatientConsultation.vue?vue&type=script&lang=ts"
export * from "./ThePatientConsultation.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__